import { render, staticRenderFns } from "./TravelRequestNotification.vue?vue&type=template&id=9983be58&scoped=true&"
import script from "./TravelRequestNotification.vue?vue&type=script&lang=js&"
export * from "./TravelRequestNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9983be58",
  null
  
)

export default component.exports